/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IBalanceDetailsResponse } from '../../entities/Prolongation/BalanceDetailsResponse';

export type TSubscriptionsProlongCurrentSubscriptionModel = IModel<
  ISubscriptionsProlongCurrentSubscriptionRequest,
  TSubscriptionsProlongCurrentSubscriptionResponse
>;

export interface ISubscriptionsProlongCurrentSubscriptionRequest {
  /** Уровень клиента в зависимости от затраченной на подписку суммы **/
  level: ELevel;
  /** Данные для холда **/
  needHold?: boolean | null;
}

export type TSubscriptionsProlongCurrentSubscriptionResponse =
  | ISubscriptionsProlongCurrentSubscriptionResponse200
  | ISubscriptionsProlongCurrentSubscriptionResponse400;

export interface ISubscriptionsProlongCurrentSubscriptionResponse200
  extends IModelResponse<ISubscriptionsProlongCurrentSubscriptionResponse> {
  statusCode: 200;
}

export interface ISubscriptionsProlongCurrentSubscriptionResponse400
  extends IModelResponse<ISubscriptionsProlongCurrentSubscriptionResponseError> {
  statusCode: 400;
}

export interface ISubscriptionsProlongCurrentSubscriptionResponse {
  balanceDetails?: IBalanceDetailsResponse | null;
  /** Статус **/
  status?: EStatus | null;
  /** Перечисление санкций, либо поясняющие ошибку тексты **/
  messages?: string[] | null;
}

export interface ISubscriptionsProlongCurrentSubscriptionResponseError {
  errors: any[];
  message: string;
}

export type TResponses =
  | ISubscriptionsProlongCurrentSubscriptionResponse
  | ISubscriptionsProlongCurrentSubscriptionResponseError;

export enum EStatus {
  /** Продление прошло успешно **/
  Ok = 'ok',
  /** Нехватка денег **/
  NotEnoughMoney = 'notEnoughMoney',
  /** Пользователь под санкциями **/
  HasSanctions = 'hasSanctions',
  /** Подписка истекла (более 3-х дней назад) **/
  Expired = 'expired',
  /** Иные ошибки **/
  Error = 'error',
}

export enum ELevel {
  /** Бронзовый **/
  Bronze = 'bronze',
  /** Серебряный **/
  Silver = 'silver',
  /** Золотой **/
  Gold = 'gold',
  /** Платиновый **/
  Platinum = 'platinum',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ISubscriptionsProlongCurrentSubscriptionResponse): TResponse200;
  400(response: ISubscriptionsProlongCurrentSubscriptionResponseError): TResponse400;
}
